import { createAction } from "@ngrx/store";

export const resetSpinner = createAction("[Spinner] disable loading spinner");